module.exports = __webpack_public_path__ + "img/r4.60730228.png";